<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İl</label>
            <v-validator :errors="errors" parameter="ProvinceId" :watch="province">
                <v-select-list v-model="province" :options="provinces" label="Name" placeholder="İl"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İlçe</label>
            <v-validator :errors="errors" parameter="DistrictId" :watch="district">
                <v-select-list :disabled="!province" v-model="district" :options="districts" label="Name" placeholder="İlçe"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Adres</label>
            <v-validator :errors="errors" parameter="Value" :watch="value.Value">
                <textarea type="text" class="form-control resize-none" placeholder="Adres" v-model="value.Value"></textarea>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Posta Kodu</label>
            <v-validator :errors="errors" parameter="PostalCode" :watch="value.PostalCode">
                <input type="text" class="form-control" placeholder="Posta Kodu" v-model="value.PostalCode">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox id="default" v-model="value.Default">Varsayılan</b-form-checkbox>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.Organisational">Organizasyonel</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            provinces:[],
            districts:[]
        }
    },
    watch:{
        "value.ProvinceId"(newValue,oldValue){
            if(newValue != oldValue){
                this.getDistricts()
                this.value.DistrictId = null
                this.value.DistrictName = null
            }
        }
    },
    mounted(){
        this.getProvinces()
        this.getDistricts()
    },
    methods:{
        getProvinces(){
            SystemDataApi.Province().then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            if(this.value.ProvinceId){
                SystemDataApi.District(this.value.ProvinceId)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        }
    },
    computed:{
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.ProvinceId)
            },
            set:function(value){
                this.value.ProvinceId = value?.Id || null
                this.value.ProvinceName = value?.Name
            }
        },
        district:{
            get:function(){
                return this.districts.find(b=>b.Id==this.value.DistrictId)
            },
            set:function(value){
                this.value.DistrictId = value?.Id || null
                this.value.DistrictName = value?.Name
            }
        }
    }
}
</script>

<style>

</style>